import { connectAutocomplete } from 'instantsearch.js/es/connectors'

const customAutocomplete = connectAutocomplete(
  ({ indices, refine, widgetParams }, isFirstRendering) => {
    const { searchBox, suggestionsContainer } = widgetParams;

    // Set up the search box listeners etc (first time)
    if (isFirstRendering) {
      // Hide the suggestions panel if the focus is lost
      const blur = function () {
        window.setTimeout(() => {
        if (!searchBox.is(':focus').length && !suggestionsContainer.is(':focus').length && !suggestionsContainer.find('a:focus').length) {
            suggestionsContainer.hide()
          }
        }, 100)
      }
      searchBox.on('blur', blur)
      suggestionsContainer.on('blur', 'a', blur)

      // Allow pressing up/down arrow keys to navigate between search box & suggestions
      // also closes panel on escape key
      searchBox.on('keydown', function (e) {
        if (e.which === 40 && suggestionsContainer.find('a').length > 0) { // down
          suggestionsContainer.find('a').first().focus()
          e.preventDefault()
          return false
        } else if (e.which === 27) { // esc
          suggestionsContainer.hide()
        }
      })
      suggestionsContainer.on('keydown', function (e) {
        const item = $(e.target)
        if (item.is('a')) {
          if (e.which === 38) { // up
            e.preventDefault()
            if (item.data('index') == 0) {
              searchBox.focus()
            } else {
              suggestionsContainer.find('a[data-index=' + (item.data('index') - 1) + ']').focus()
            }
            return false
          } else if (e.which === 40) { // down
            e.preventDefault()
            const nextItem = suggestionsContainer.find('a[data-index=' + (item.data('index') + 1) + ']')
            if (nextItem.length) {
              nextItem.focus()
            }
            return false
          } else if (e.which === 27) { // esc
            suggestionsContainer.hide()
            searchBox.focus()
          }
        }
      })

      searchBox.on('input', function () {
        refine($(this).val())
      })
      suggestionsContainer.on('click', 'a', function (e) {
        e.preventDefault()
        searchBox.focus()
        searchBox.val($(this).text())
        refine($(this).text())
      })
    }

    // Render the suggestions under search box (if there are any)
    const queries = []
    const currentVal = searchBox.val()
    indices.forEach(({ results }) => {
      results.hits.forEach(hit => {
        if (hit.query !== currentVal) { // Remove current query from suggestions
          queries.push(hit.query)
        }
      })
    })
    if (queries.length && searchBox.val().trim() !== '') {
      suggestionsContainer.html(queries.slice(0, 5).map((q, i) => `
        <a href="#" class="c-search-form__suggestion-item" data-index="${i}">${q}</a>
      `))
      // Only show if we're still focused on the search box
      suggestionsContainer.toggle(searchBox.is(':focus'))
    } else {
      suggestionsContainer.hide()
    }
  }
);

export default customAutocomplete
